// components/common/Layout.jsx
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopNavbar from './TopNavbar';

const Layout = ({ 
  children, 
  title = 'Business Management',
  activeMenu = 'business',
  onMenuChange 
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  const handleMenuChange = (menu) => {
    if (onMenuChange) {
      onMenuChange(menu);
    }
    // Close sidebar on mobile after menu selection
    setSidebarOpen(false);
  };

  return (
    <div className="d-flex" style={{ minHeight: '100vh' }}>
      <Sidebar 
        isOpen={sidebarOpen}
        onClose={handleSidebarClose}
        activeMenu={activeMenu}
        onMenuChange={handleMenuChange}
      />
      
      <div className="main-content">
        <TopNavbar 
          onToggleSidebar={toggleSidebar}
          title={title}
        />
        
        <div className="content-area">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;